<sgt-modal [isOpen]="isOpen" [settings]="modalSettings" (closed)="onClose()">
  <div header>
    <h5 class="modal__title mb-0">
      <i class="fas fa-sliders-h mr-2"></i>Filtros Avançados
    </h5>
  </div>

  <div body>
    <div class="filter-sidebar" *ngIf="advancedFiltersForm" [formGroup]="advancedFiltersForm">
      <!-- Identificação -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-id-card"></i> Identificação
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Tipo</label>
              <sgt-novo-pessoa-tipo-multiselect
                formControlName="tiposPessoas"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-pessoa-tipo-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Código ERP</label>
              <input
                type="text"
                class="form-control form-control-sm"
                formControlName="codigoIntegracaoErp"
                placeholder="Código ERP"
              />
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">CNPJ/CPF</label>
              <input
                type="text"
                class="form-control form-control-sm"
                formControlName="cnpjCpf"
                sgtNovoCnpjCpf
                placeholder="00.000.000/0000-00"
              />
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Grupo Econômico</label>
              <sgt-novo-cliente-grupo-economico-select
                formControlName="idClienteGrupoEconomico"
              >
              </sgt-novo-cliente-grupo-economico-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Acessos -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-user-shield"></i> Acessos
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Gerentes</label>
              <sgt-usuario-multi-select
                formControlName="idsGerentes"
                [perfil]="EnumUsuarioPerfil.GERENTE"
                [situacao]="EnumSituacao.ATIVO"
                [settings]="{
                  placeholder: 'Selecione os gerentes',
                  singular: 'Gerente',
                  plural: 'Gerentes',
                  showFooter: false
                }"
              >
              </sgt-usuario-multi-select>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Atendentes</label>
              <sgt-usuario-multi-select
                formControlName="idsAtendentes"
                [perfil]="EnumUsuarioPerfil.ATENDENTE"
                [situacao]="EnumSituacao.ATIVO"
                [settings]="{
                  placeholder: 'Selecione os atendentes',
                  singular: 'Atendente',
                  plural: 'Atendentes',
                  showFooter: false
                }"
              >
              </sgt-usuario-multi-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Origem -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-star-of-life"></i> Origem
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">
                Origens
                <i
                  class="fas fa-info-circle"
                  sgtTooltip="Origens dos prospects e clientes"
                  tooltipPosition="right"
                ></i>
              </label>
              <sgt-novo-origem-multi-select
                formControlName="origens"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-origem-multi-select>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">
                Canais de Venda de Origem
                <i
                  class="fas fa-info-circle"
                  sgtTooltip="Canais de Venda de origem dos prospects e clientes"
                  tooltipPosition="right"
                ></i>
              </label>
              <sgt-novo-canal-venda-multi-select
                formControlName="idsCanaisVendaOrigem"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-canal-venda-multi-select>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">
                Canais de Mídias Sociais
                <i
                  class="fas fa-info-circle"
                  sgtTooltip="Canais de Mídias Sociais de origem dos prospects e clientes"
                  tooltipPosition="right"
                ></i>
              </label>
              <sgt-novo-canal-midia-social-multi-select
                formControlName="canaisMidiasSociais"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-canal-midia-social-multi-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Campanhas -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-bullhorn"></i> Campanhas
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">
                Campanhas Origens
                <i
                  class="fas fa-info-circle"
                  sgtTooltip="Campanhas de origem dos prospects e clientes"
                  tooltipPosition="right"
                ></i>
              </label>
              <sgt-novo-campanha-multi-select
                formControlName="idsCampanhasOrigens"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-campanha-multi-select>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">
                Campanhas Aquisições
                <i
                  class="fas fa-info-circle"
                  sgtTooltip="Campanhas de aquisição dos clientes"
                  tooltipPosition="right"
                ></i>
              </label>
              <sgt-novo-campanha-multi-select
                formControlName="idsCampanhasAquisicoes"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-campanha-multi-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Compras -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-shopping-cart"></i> Compras
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Periodicidades de Compras</label>
              <sgt-novo-periodicidade-compra-multi-select
                formControlName="idsPeriodicidadesCompras"
                [settings]="{ showFooter: false }"
              >
              </sgt-novo-periodicidade-compra-multi-select>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Semanas</label>
              <sgt-novo-semana-multi-select
                formControlName="periodicidadeCompraSemana"
                [settings]="{ showFooter: false }">
              </sgt-novo-semana-multi-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Dados Cadastrais -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-calendar-alt"></i> Dados Cadastrais
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div
              class="form-group col-12"
              *ngIf="config?.canVisualizarStatusesAnaliseFinanceira"
            >
              <label class="col-form-label">Análise Financeira</label>
              <sgt-cliente-analise-financeira-status-multiselect
                [(statuses)]="statusesAnaliseFinanceira"
              >
              </sgt-cliente-analise-financeira-status-multiselect>
            </div>
            <div class="form-group col-6">
              <label class="col-form-label">Cadastro Inicial</label>
              <sgt-novo-datepicker
                formControlName="dataCadastroInicial"
                [settings]="{ periodicidades: ['diaria'] }"
              >
              </sgt-novo-datepicker>
            </div>
            <div class="form-group col-6">
              <label class="col-form-label">Cadastro Final</label>
              <sgt-novo-datepicker
                formControlName="dataCadastroFinal"
                [settings]="{ periodicidades: ['diaria'] }"
              >
              </sgt-novo-datepicker>
            </div>
            <div
              class="form-group col-12"
              *ngIf="config?.isModoCentralCompraCadastro"
            >
              <label class="col-form-label">Central de Compras</label>
              <sgt-novo-typeahead-cliente-central-compra
                formControlName="clienteCentralCompras"
              >
              </sgt-novo-typeahead-cliente-central-compra>
            </div>
          </div>
        </div>
      </div>

      <!-- Localização -->
      <div class="filter-section">
        <h6 class="filter-section__title">
          <i class="fas fa-map-marker-alt"></i> Localização
        </h6>
        <div class="filter-section__content">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Regiões</label>
              <sgt-novo-regiao-multiselect
                formControlName="idsRegioes"
                [settings]="{ showFooter: false }"
                [somenteAtivas]="somenteRegioesAtivas"
              >
              </sgt-novo-regiao-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Estados</label>
              <sgt-novo-estado-multiselect
               formControlName="idEstado">
              </sgt-novo-estado-multiselect>
            </div>
            <div class="form-group col-12">
              <label class="col-form-label">Cidade</label>
              <sgt-novo-typeahead-cidade
                formControlName="idCidade"
              >
              </sgt-novo-typeahead-cidade>
            </div>
            <div class="form-group col-12 col-md-6">
              <label class="col-form-label">Sub-região</label>
              <sgt-select
                formControlName="idCidadeSubRegiao"
                [options]="subRegioesOptions"
                [settings]="subRegiaoSettings"
              >
              </sgt-select>
            </div>
            <div class="form-group col-12 col-md-6">
              <label class="col-form-label">Bairro da Sub-região</label>
              <sgt-select
                formControlName="idCidadeSubRegiaoBairro"
                [options]="bairrosOptions"
                [settings]="bairroSettings"
              >
              </sgt-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div footer>
    <div class="filter-sidebar__footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="onClear()"
      >
        <i class="fas fa-eraser"></i> Limpar
      </button>
      <button type="button" class="btn btn-primary" (click)="onApply()">
        <i class="fas fa-filter"></i> Aplicar Filtros
      </button>
    </div>
  </div>
</sgt-modal>
